import { SmartJd } from '../../models/smart-jd.model';

/** The sample JDs the upload dialog offers in mock mode. One builds; the other fails. */
export const SAMPLE_JD_FILE = 'Generalist Fullstack JD.pdf';
export const SAMPLE_FAILING_JD_FILE = 'Unreadable JD.pdf';

/** The sample Smart JD from Recruit Service, exactly as the wire delivers it. */
export const SMART_JD_SEED: SmartJd = {
  "company": {
    "id": {
      "value": "5f31f9ce-a9b9-4e4c-8aaa-9fd999a2f1bf",
      "provenance": "policy",
      "confidence": 1,
      "evidence": null
    },
    "name": {
      "value": "MuyCio",
      "provenance": "policy",
      "confidence": 1,
      "evidence": null
    },
    "domain": null,
    "hq_location": null,
    "other_locations": null
  },
  "role": {
    "notice_period": {
      "max_days": 20,
      "negotiable": null,
      "buyout_available": null,
      "provenance": "stated",
      "confidence": 0.98,
      "evidence": "Immediately- Serving NP within 20 days available candidates only",
      "importance": "NN"
    },
    "name": {
      "value": "Generalist Fullstack",
      "provenance": "stated",
      "confidence": 0.98,
      "evidence": null
    },
    "role_type": {
      "value": "Fullstack",
      "provenance": "stated",
      "confidence": 0.95,
      "evidence": null
    },
    "years_of_experience": {
      "flexibility_note": null,
      "provenance": "stated",
      "confidence": 0.59,
      "evidence": "Salary bands : ● 5-10 - 31 LPA ( 28-29 LPA for 5 years)",
      "importance": "UNKNOWN",
      "min_years": 5,
      "max_years": 10
    },
    "location": {
      "provenance": "stated",
      "confidence": 0.95,
      "evidence": "WFO,\nBelandur, Bangalore",
      "importance": "NN",
      "cities": [
        "Bangalore"
      ],
      "work_from_office_mandatory": true
    }
  },
  "requirements": [
    {
      "provenance": "stated",
      "importance": "NN",
      "id": "r0",
      "assessed_in": "resume",
      "disclosure": "expected",
      "acceptance_criteria": "Has 5 or more years of relevant professional experience.",
      "confidence": 0.98,
      "evidence": "Avoid : ○ &amp;lt;5 years (lack depth)",
      "criteria": "At least 5 years of experience",
      "description": null
    },
    {
      "provenance": "stated",
      "confidence": 0.99,
      "importance": "NN",
      "criteria": "Able to join immediately or serving a notice period within 20 days",
      "description": null,
      "assessed_in": "screening",
      "evidence": "Immediately- Serving NP within 20 days available candidates only",
      "id": "r1",
      "disclosure": "optional",
      "acceptance_criteria": "Can join immediately, or is currently serving notice and available within 20 days."
    },
    {
      "id": "r2",
      "criteria": "Based in or able to work from office in Bellandur, Bangalore",
      "description": null,
      "acceptance_criteria": "Based in Bangalore, or willing to work from the Bellandur office, in a work-from-office setup.",
      "provenance": "stated",
      "evidence": "WFO,\nBelandur, Bangalore",
      "assessed_in": "resume",
      "disclosure": "expected",
      "confidence": 0.95,
      "importance": "NN"
    },
    {
      "provenance": "inferred",
      "evidence": null,
      "id": "r3",
      "criteria": "Hands-on fullstack experience with both frontend and backend",
      "description": null,
      "assessed_in": "resume",
      "acceptance_criteria": "Shows hands-on work across both frontend/UI and backend, not only backend experience.",
      "confidence": 0.3,
      "importance": "NN",
      "disclosure": "expected"
    },
    {
      "provenance": "stated",
      "confidence": 0.93,
      "assessed_in": "resume",
      "acceptance_criteria": "Shows meaningful frontend/UI experience sufficient to contribute in a full-stack, end-to-end role.",
      "evidence": "Whether they have enough UI exposure for a full-stack / end-to-end role",
      "importance": "DIFF",
      "id": "r4",
      "criteria": "Strong enough UI exposure to work in a full-stack or end-to-end role",
      "description": null,
      "disclosure": "expected"
    },
    {
      "id": "r5",
      "criteria": "Backend depth in at least one of Java, Python, NodeJS, or Golang",
      "description": null,
      "assessed_in": "resume",
      "acceptance_criteria": "Shows substantial backend experience in at least one of these languages: Java, Python, NodeJS, or Golang.",
      "confidence": 0.91,
      "evidence": "Check Backend Depth - which language and how many years in each tech (Java,\nPython,\n\nNodeJS,\n\nGolang-",
      "importance": "NN",
      "disclosure": "expected",
      "provenance": "stated"
    },
    {
      "evidence": "NodeJS\nis\npreferred\n-)",
      "importance": "DIFF",
      "id": "r6",
      "acceptance_criteria": "Shows backend experience with NodeJS.",
      "provenance": "stated",
      "confidence": 0.86,
      "criteria": "Experience with NodeJS",
      "description": null,
      "assessed_in": "resume",
      "disclosure": "optional"
    },
    {
      "evidence": "Must have good exposure with AWS and SQL",
      "importance": "DIFF",
      "id": "r7",
      "criteria": "Good exposure to AWS",
      "description": null,
      "disclosure": "optional",
      "acceptance_criteria": "Shows good exposure to AWS.",
      "confidence": 0.98,
      "assessed_in": "resume",
      "provenance": "stated"
    },
    {
      "confidence": 0.98,
      "criteria": "Good exposure to SQL",
      "description": null,
      "acceptance_criteria": "Shows good exposure to SQL.",
      "provenance": "stated",
      "evidence": "Must have good exposure with AWS and SQL",
      "importance": "DIFF",
      "id": "r8",
      "assessed_in": "resume",
      "disclosure": "expected"
    },
    {
      "assessed_in": "resume",
      "confidence": 0.84,
      "criteria": "Knows how to manage state in the UI",
      "description": null,
      "disclosure": "optional",
      "acceptance_criteria": "Can explain how they manage state in frontend/UI applications.",
      "provenance": "stated",
      "evidence": "How they manage state in the UI",
      "importance": "EXP",
      "id": "r9"
    },
    {
      "assessed_in": "screening",
      "disclosure": "optional",
      "acceptance_criteria": "Is currently hands-on and able to contribute heavily to coding work, not just leadership or guidance.",
      "provenance": "stated",
      "evidence": "This\nrole\nis\n90%\ncoding.\n\nSo\nthe\ncandidates\nshouldn't\nassume\nthey'll\nbe\na\nrun-of-the-mill\n\ntech\n\nlead\n\nwhere\n\nthey'll\n\njust\n\ngive\n\nguidance.",
      "id": "r10",
      "criteria": "Currently hands-on in coding rather than only providing guidance",
      "description": null,
      "confidence": 0.92,
      "importance": "EXP"
    },
    {
      "id": "r11",
      "criteria": "Willing to travel to the Bangalore office for quarterly planning",
      "description": null,
      "acceptance_criteria": "Candidate confirms they can travel once a quarter.",
      "assessed_in": "screening",
      "disclosure": "optional",
      "importance": "NR",
      "provenance": "inferred",
      "confidence": 0.44,
      "evidence": null
    }
  ],
  "advanced_rubrics": [
    {
      "name": "scale",
      "rule": "satisfy_at_least",
      "n": 2,
      "criteria": [
        "Worked on a product serving over a million users",
        "Owned a service through a traffic spike",
        "Tuned queries or caching against real load"
      ],
      "importance": "DIFF",
      "provenance": "inferred",
      "confidence": 0.72,
      "evidence": null
    }
  ],
  "antipatterns": [
    {
      "evidence": "Avoid : ○ &amp;lt;5 years (lack depth)",
      "importance": "NN",
      "id": "a0",
      "assessed_in": "resume",
      "disclosure": "expected",
      "acceptance_criteria": "Shows total relevant experience of under 5 years.",
      "provenance": "stated",
      "confidence": 0.98,
      "criteria": "Less than 5 years of experience",
      "description": null
    },
    {
      "provenance": "inferred",
      "confidence": 0.3,
      "evidence": null,
      "importance": "NN",
      "assessed_in": "resume",
      "id": "a1",
      "criteria": "Frequent job hopping with short stints",
      "description": null,
      "disclosure": "expected",
      "acceptance_criteria": "Employment history shows frequent job changes with short tenures."
    }
  ]
};
